import { Tooltip } from '@mui/material';
import React from 'react';
import Input from 'shared/component/inputFields';
import TextArea from 'shared/component/textArea';
const Destinations = (props) => {

  const next = data => {
     data.preventDefault();
    props.nextStep();
  }

  return (
    <form onSubmit={next} className='myorder'>
        <div className='container destinations'>
        <div className='steps'>
                    <Tooltip title="NEW ORDER" arrow>
                        <span className='indicator done'></span>
                    </Tooltip>
                    <Tooltip title="SHIPPING DETAILS" arrow>
                        <span className='indicator done'></span>
                    </Tooltip>
                    <Tooltip title="FROM DETAILS" arrow>
                        <span className='indicator done'></span>
                    </Tooltip>
                    <Tooltip title="TO DETAILS" arrow>
                        <span className='indicator done'></span>
                    </Tooltip>
                    <Tooltip title="DESTINATIONS" arrow>
                        <span className='indicator active'></span>
                    </Tooltip>
                    <Tooltip title="SUMMARY" arrow>
                        <span className='indicator'></span>
                    </Tooltip>
                    <Tooltip title="PENDING" arrow>
                        <span className='indicator'></span>
                    </Tooltip>
                </div>

        <div className='box-order'>
            <div className='order-header'>
                <h1 className='title'>STOP NO. 1</h1>
                <hr className='hr' />
            </div>

            <div className='row'>
                <div className='col-md-6'>
                    <Input dashed type="text" label="From" value="cairo" />
                </div>
                <div className='col-md-6'>
                <Input type="select" label="To" />
                </div>
                <div className='col-md-6'>
                <Input type="text" label="Contact Person:" />
                </div>
                <div className='col-md-2'>
                <Input type="select" label="Code" />
                </div>
                <div className='col-md-4'>
                <Input type="text" label="Phone:" />
                </div>
                <div className='col-md-6'>
                <Input type="text" label="Addresses:" />
                </div>
                <div className='col-md-6'>
                <Input type="text" label="Location:" location />
                </div>
                <div className='col-md-12'>
                    <TextArea label="Address Details:" />
                </div>
            </div>

            </div>

            <div className='box-order'>
            <div className='order-header'>
                <h1 className='title'>STOP NO. 2</h1>
                <hr className='hr' />
            </div>
            <div className='row'>
                <div className='col-md-6'>
                    <Input dashed type="text" label="From" value="cairo" />
                </div>
                <div className='col-md-6'>
                <Input type="select" label="To" />
                </div>
                <div className='col-md-6'>
                <Input type="text" label="Contact Person:" />
                </div>
                <div className='col-md-2'>
                <Input type="select" label="Code" />
                </div>
                <div className='col-md-4'>
                <Input type="text" label="Phone:" />
                </div>
                <div className='col-md-6'>
                <Input type="text" label="Addresses:" />
                </div>
                <div className='col-md-6'>
                <Input type="text" label="Location:" location/>
                </div>
                <div className='col-md-12'>
                    <TextArea label="Address Details:" />
                </div>
            </div>
            </div>
        </div>

      <div className='action'>
        <div className='container'>
          <button type='button' className='btn-border-blue' onClick={props.previousStep}>Back</button>
          <button type='submit'  className='btn-blue'>Next</button>
        </div>
      </div>

    </form>
  )
}

export default Destinations